import React from 'react';
import { BodySmallText } from '@prisjakt/ui/text/variants';
import { PricePrice } from 'src/types';
import ShippingLabelComponent from '../../../../../../../components/shipping-label';

import * as S from './styles';
import { PriceDisplayEnum, PriceDisplay } from 'src/areas/product/types';

const ShippingLabel: React.FC<IShippingLabelProps> = ({
  price,
  priceDisplay,
}) => {
  const shippingLabel = () => (
    <S.ShippingLabelWrapper>
      {price.exclShipping && (
        <BodySmallText>
          <ShippingLabelComponent
            toneDown
            exclShipping={price.exclShipping}
            inclShipping={price.inclShipping}
            priceDisplay={priceDisplay}
          />
        </BodySmallText>
      )}
    </S.ShippingLabelWrapper>
  );

  if (
    (priceDisplay !== PriceDisplayEnum.PRICE_INCLUDES_SHIPPING &&
      price.inclShipping) ||
    (priceDisplay === PriceDisplayEnum.PRICE_INCLUDES_SHIPPING &&
      !price.inclShipping)
  ) {
    return shippingLabel();
  }

  if (
    price.inclShipping ||
    (priceDisplay === PriceDisplayEnum.PRICE_INCLUDES_SHIPPING &&
      !price.inclShipping)
  ) {
    return shippingLabel();
  }

  return null;
};

interface IShippingLabelProps {
  price: PricePrice;
  priceDisplay: PriceDisplay;
}

export default ShippingLabel;
